(function () {
    'use strict';

    angular
        .module('app.shared')
        .constant('handicapHistoryResolver', {
            history: getHandicapHistory,
            individualId: getIndividualId,
            offsetInDays: getOffsetInDays,
        });

    getIndividualId.$inject = ['$transition$', 'user'];
    function getIndividualId($transition$, user) {
        return $transition$.params().individualId || user.id;
    }

    getHandicapHistory.$inject = ['Member', '$transition$', 'user'];
    function getHandicapHistory(Member, $transition$, user) {
        var individualId = getIndividualId($transition$, user),
            offsetInDays = getOffsetInDays();

        return Member.getHandicapHistory({ id: individualId, offsetInDays: offsetInDays }, true).$promise;
    }

    function getOffsetInDays() {
        return -30;
    }
})();